import * as React from 'react'

function IconBlockedLesson(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={67}
      height={67}
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.497 66c17.947 0 32.496-14.55 32.496-32.5S51.444 1 33.497 1C15.549 1 1 15.55 1 33.5S15.55 66 33.497 66z"
        fill="#fff"
      />
      <path
        d="M33.497 66c17.947 0 32.496-14.55 32.496-32.5S51.444 1 33.497 1C15.549 1 1 15.55 1 33.5S15.55 66 33.497 66z"
        stroke="#A3A3A3"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M33.497 61.445c15.432 0 27.942-12.512 27.942-27.945S48.929 5.555 33.497 5.555 5.555 18.067 5.555 33.5s12.51 27.945 27.942 27.945z"
        fill="#A3A3A3"
      />
      <path
        d="M26.583 26.583l13.692 14.134M40.275 26.583L26.583 40.717"
        stroke="#fff"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconBlockedLesson
